export const ACTIONS = {
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete',
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete'
}